import React from "react"
import { FormProvider } from "react-hook-form"

import { noop } from "shared/lib/noop"

import { ReferenceFilterChipList } from "entities/building-references/ui/reference-filter-chip-list/ReferenceFilterChipList"

import { BuildingReferenceFilterViewModel } from "../model/useBuildingReferenceFilterViewModel"
import "../styles/_building-reference-filter.scss"
import { BuildingReferenceProductFilterInput } from "./BuildingReferenceProductFilterInput"
import { BuildingReferenceSearchInput } from "./BuildingReferenceSearchInput"
import { BuildingReferenceTypeFilterInput } from "./BuildingReferenceTypeFilterInput"

export interface BuildingReferenceFilterViewProps
  extends BuildingReferenceFilterViewModel {}

export const BuildingReferenceFilterView = React.memo(
  ({
    form,
    formValues,

    productOptions,

    isLoading,

    onChange
  }: BuildingReferenceFilterViewProps) => {
    return (
      <FormProvider {...form}>
        <form
          id="building-reference-filter"
          className="building-reference-filter"
          data-testid="building-reference-filter"
          onSubmit={form.handleSubmit(noop)}
        >
          <div className="building-reference-filter__inputs">
            <BuildingReferenceProductFilterInput
              options={productOptions}
              disabled={isLoading}
            />
            <BuildingReferenceTypeFilterInput disabled={isLoading} />
            <BuildingReferenceSearchInput disabled={isLoading} />
          </div>
          <ReferenceFilterChipList
            filterState={formValues}
            onChange={onChange}
            productOptions={productOptions}
          />
        </form>
      </FormProvider>
    )
  }
)

BuildingReferenceFilterView.displayName = "BuildingReferenceFilterView"
